import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import fetch from './../../fetch';
import { baseUrl, customHeaders, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';

import { GET_COUPON_FACILITY, GET_COUPON_FACILITY_SUCCESS, GET_COUPON_FACILITY_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant';

function* getFacility({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/admin/facilities`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        pageIndex: 0,
        pageSize: 100,
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_COUPON_FACILITY_SUCCESS,
        payload: response?.data?.results,
      });
    } else {
      yield put({
        type: GET_COUPON_FACILITY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_COUPON_FACILITY_ERROR, payload: error });
  }
}

export function* watchGetFacility() {
  yield takeEvery(GET_COUPON_FACILITY, getFacility);
}

function* getCouponFacilitySaga() {
  yield all([fork(watchGetFacility)]);
}

export default getCouponFacilitySaga;
